import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const makeBannersInactive = async (data: number[]) => {
	const response = await cmsClient.delete<unknown>(
		"/homepage/admin/fullscreentakeover/publish/",
		{ data }
	);

	return response.data;
};

const useMakeFullScreenTakeoverBannersInactive = () => {
	const queryClient = useQueryClient();

	const onSuccess = async () => {
		toast.success(
			<CustomToast
				type="Success"
				message="Banner(s) inactive - moved to library"
			/>,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["full-screen-takeover-active-banners"]);
		queryClient.invalidateQueries(["full-screen-takeover-banner-library"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(makeBannersInactive, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useMakeFullScreenTakeoverBannersInactive;
